import { create as o } from "zustand";
const s = o((e) => ({
  isContentObscured: !1,
  setContentObscured(t) {
    e({ isContentObscured: t });
  }
}));
export {
  s as useLayoutStore
};
